import { render, staticRenderFns } from "./ProjectFindings.vue?vue&type=template&id=d5f5dee2&"
import script from "./ProjectFindings.vue?vue&type=script&lang=js&"
export * from "./ProjectFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f5dee2')) {
      api.createRecord('d5f5dee2', component.options)
    } else {
      api.reload('d5f5dee2', component.options)
    }
    module.hot.accept("./ProjectFindings.vue?vue&type=template&id=d5f5dee2&", function () {
      api.rerender('d5f5dee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectFindings.vue"
export default component.exports